import React from 'react';
import classnames from 'classnames';
import { Pane, Flex, ToggleButton } from '@leverege/ui-elements';
import { LabelText, ValueText, DetailUtil } from '@leverege/ui-attributes';
import Model from "../model/StatsAggTextViewModel.js";
import AggsUtil from "../../util/AggsUtil.js";
import S from './BucketAggTextView.css';
import { buildVariant } from "../../util/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function StatsAggTextView(props) {
  const {
    value,
    data,
    className,
    vertical,
    hasHeaders = true
  } = props;
  let {
    variant
  } = props;
  variant = Model.getVariant(value) || variant;
  if (!data) {
    return null;
  }
  const hLStyle = DetailUtil.getStyle(value?.header?.label);
  const vLStyle = DetailUtil.getStyle(value?.value?.label);
  const vTStyle = DetailUtil.getStyle(value?.value?.text);
  const roundTo = Model.getRoundTo(value);
  const bucketLabelVariant = buildVariant(variant, 'Label');
  const bucketValueVariant = buildVariant(variant, 'Value');
  const bucketFlexVariant = buildVariant(variant, 'BucketFlex', 'colLStart');
  const headerLabel = Model.getHeaderLabel(value);
  return /*#__PURE__*/_jsx(Pane, {
    variant: buildVariant(variant, 'Item'),
    className: classnames(className, S.pane),
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: buildVariant(variant, 'ContainerFlex', 'colMStart'),
      className: S.colFlex,
      children: [hasHeaders && /*#__PURE__*/_jsx(LabelText, {
        variant: buildVariant(variant, 'Title'),
        style: {
          ...hLStyle,
          visibility: headerLabel ? 'visible' : 'hidden'
        },
        children: headerLabel || 'M'
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: vertical ? 'aggBucketVertical' : 'aggBucketHorizontal',
        style: {
          flexWrap: vertical ? 'wrap' : undefined,
          width: vertical ? '100%' : undefined,
          flexGrow: 1
        },
        children: [Model.getShowCount(value) && /*#__PURE__*/_jsx(StatsAggTextViewItem, {
          bucketFlexVariant: bucketFlexVariant,
          bucketLabelVariant: bucketLabelVariant,
          bucketValueVariant: bucketValueVariant,
          data: data,
          roundTo: roundTo,
          value: value,
          vLStyle: vLStyle,
          vTStyle: vTStyle,
          getter: Model.getCountValue,
          dataKey: "count",
          variant: variant
        }), Model.getShowMin(value) && /*#__PURE__*/_jsx(StatsAggTextViewItem, {
          bucketFlexVariant: bucketFlexVariant,
          bucketLabelVariant: bucketLabelVariant,
          bucketValueVariant: bucketValueVariant,
          data: data,
          roundTo: roundTo,
          value: value,
          vLStyle: vLStyle,
          vTStyle: vTStyle,
          getter: Model.getMinValue,
          dataKey: "min",
          variant: variant
        }), Model.getShowMax(value) && /*#__PURE__*/_jsx(StatsAggTextViewItem, {
          bucketFlexVariant: bucketFlexVariant,
          bucketLabelVariant: bucketLabelVariant,
          bucketValueVariant: bucketValueVariant,
          data: data,
          roundTo: roundTo,
          value: value,
          vLStyle: vLStyle,
          vTStyle: vTStyle,
          getter: Model.getMaxValue,
          dataKey: "max",
          variant: variant
        }), Model.getShowAvg(value) && /*#__PURE__*/_jsx(StatsAggTextViewItem, {
          bucketFlexVariant: bucketFlexVariant,
          bucketLabelVariant: bucketLabelVariant,
          bucketValueVariant: bucketValueVariant,
          data: data,
          roundTo: roundTo,
          value: value,
          vLStyle: vLStyle,
          vTStyle: vTStyle,
          getter: Model.getAvgValue,
          dataKey: "avg",
          variant: variant
        }), Model.getShowSum(value) && /*#__PURE__*/_jsx(StatsAggTextViewItem, {
          bucketFlexVariant: bucketFlexVariant,
          bucketLabelVariant: bucketLabelVariant,
          bucketValueVariant: bucketValueVariant,
          data: data,
          roundTo: roundTo,
          value: value,
          vLStyle: vLStyle,
          vTStyle: vTStyle,
          getter: Model.getSumValue,
          dataKey: "sum",
          variant: variant
        })]
      })]
    })
  });
}
function StatsAggTextViewItem({
  bucketFlexVariant,
  bucketLabelVariant,
  bucketValueVariant,
  data,
  roundTo,
  value,
  vLStyle,
  vTStyle,
  getter,
  dataKey,
  variant
}) {
  return /*#__PURE__*/_jsx(ToggleButton, {
    disabled: true,
    variant: buildVariant(variant),
    children: /*#__PURE__*/_jsxs(Flex, {
      className: S.bucket,
      variant: bucketFlexVariant,
      children: [/*#__PURE__*/_jsx(LabelText, {
        variant: bucketLabelVariant,
        style: vLStyle,
        children: getter(value)
      }), /*#__PURE__*/_jsx(ValueText, {
        variant: bucketValueVariant,
        style: vTStyle,
        children: AggsUtil.roundTo(data[dataKey], roundTo)
      })]
    })
  });
}